import React from 'react'

import Radio from '@mui/material/Radio'
import RadioGroup from '@mui/material/RadioGroup'
import FormControlLabel from '@mui/material/FormControlLabel'
import FormControl from '@mui/material/FormControl'
import FormLabel from '@mui/material/FormLabel'

interface RadioButtonProps {
  disabled?: boolean
  value: number
  label: string
  groupName: string
  options: Array<{ id: number; value: number; label: string }>
  onChange: (newValue: number) => void
}

const RadioButton = (props: RadioButtonProps): JSX.Element => {
  return (
    <FormControl sx={{ mb: 3, mr: 3 }}>
      <FormLabel id={`${props.groupName}-label`}>{props.label}</FormLabel>
      <RadioGroup
        row
        sx={{ flexWrap: 'nowrap' }}
        aria-labelledby={`${props.groupName}-label`}
        name={props.groupName}
        value={props.value}
        onChange={(event: React.ChangeEvent<HTMLInputElement>) => props.onChange(parseInt(event.target.value))}
      >
        {props.options.map((x) => (
          <FormControlLabel
            key={x.value}
            className="radio-connector"
            value={x.value}
            control={<Radio disabled={props.disabled} />}
            label={x.label}
            labelPlacement="bottom"
          />
        ))}
      </RadioGroup>
    </FormControl>
  )
}

export default RadioButton
